import {Record as record, Map} from 'immutable';

// Certain elements on the page are open exlusive.
// Create action handlers that set this enum.
// Selectors will use this flag to determine what is open and closed.
const OpenModalStates = {
    AMENITY: 'AMENITY',
    BOOKING_FLOW_DATE_PICKER: 'BOOKING_FLOW_DATE_PICKER',
    BOOKING_FLOW_GUEST_SELECTOR: 'BOOKING_FLOW_GUEST_SELECTOR',
    CAROUSEL: 'CAROUSEL',
    CIVIL_CODE_DISCLAIMER: 'CIVIL_CODE_DISCLAIMER',
    DATE_PICKER: 'DATE_PICKER',
    DESCRIPTION: 'DESCRIPTION',
    GUEST_SELECTOR: 'GUEST_SELECTOR',
    IMAGE_CAROUSEL: 'IMAGE_CAROUSEL',
    INQUIRY_DATE_PICKER: 'INQUIRY_DATE_PICKER',
    INQUIRY_GUEST_SELECTOR: 'INQUIRY_GUEST_SELECTOR',
    INQUIRY_LOGIN_EXPERIENCE: 'INQUIRY_LOGIN_EXPERIENCE',
    INQUIRY: 'INQUIRY',
    LOCATION: 'LOCATION',
    LOGIN_EXPERIENCE: 'LOGIN_EXPERIENCE',
    MAIN_PAGE_DATE_PICKER: 'MAIN_PAGE_DATE_PICKER',
    MAIN_PAGE_GUEST_SELECTOR: 'MAIN_PAGE_GUEST_SELECTOR',
    MAP: 'MAP',
    NONE: 'NONE',
    OWNER_PROFILE: 'OWNER_PROFILE',
    REPORT_THIS_LISTING: 'REPORT_THIS_LISTING',
    REQUEST_TO_BOOK_DATE_PICKER: 'REQUEST_TO_BOOK_DATE_PICKER',
    REQUEST_TO_BOOK_GUEST_SELECTOR: 'REQUEST_TO_BOOK_GUEST_SELECTOR',
    REQUEST_TO_BOOK: 'REQUEST_TO_BOOK',
    REVIEWS: 'REVIEWS',
    SEARCH_DATE_PICKER: 'SEARCH_DATE_PICKER',
    SEARCH_GUEST_PICKER: 'SEARCH_GUEST_PICKER',
    SEARCH: 'SEARCH',
    UNIT_DESCRIPTION: 'UNIT_DESCRIPTION',
    VERTICAL_GALLERY: 'VERTICAL_GALLERY',
    VIRTUAL_TOUR: 'VIRTUAL_TOUR',
    TOI_MAP: 'TOI_MAP'
};

const OpenPopoverStates = {
    NONE: 'NONE',
    RIGHT_RAIL_ARRIVE_DATE: 'RIGHT_RAIL_ARRIVE_DATE',
    RIGHT_RAIL_DEPART_DATE: 'RIGHT_RAIL_DEPART_DATE',
    RIGHT_RAIL_GUEST_SELECTOR: 'RIGHT_RAIL_GUEST_SELECTOR',
    REQUEST_ARRIVE_DATE: 'REQUEST_ARRIVE_DATE',
    REQUEST_DEPART_DATE: 'REQUEST_DEPART_DATE',
    REQUEST_GUEST_SELECTOR: 'REQUEST_GUEST_SELECTOR'
};

const InquiryStates = {
    NONE: 'NONE',
    MSG_POSTING: 'MSG_POSTING',
    MSG_SEND_SUCCESS: 'MSG_SEND_SUCCESS',
    MSG_SEND_FAILURE: 'MSG_SEND_FAILURE'
};

const ListingPageRecord = record(
    {
        openModalState: OpenModalStates.NONE,
        openPopoverState: OpenPopoverStates.NONE,
        isTypeaheadInputFocused: false,
        inquiryState: InquiryStates.NONE,
        inquiryUUID: '',
        inquiryServiceErrors: new Map(),
        loadingRate: true,
        rate: 0,
        pricingInfo: {}, // PDS Pricing retrieval data
        priceDetails: {}, // graphql-traveler-checkout results from priceDetails.
        pricingKey: new Map(),
        validDates: {
            datesValid: null,
            datesEmpty: null,
            hasMinStayError: null,
            hasMinPriorNotifyError: null,
            hasSameDayArrivalError: null,
            hasUnavailableDates: null
        },
        validGuests: true,
        enterDatesTimerComplete: false,
        showDescriptionDisclaimerControl: true,
        showAlert: false
    },
    'ListingPageRecord'
);

export default ListingPageRecord;
export {ListingPageRecord, OpenModalStates, OpenPopoverStates, InquiryStates};
